<template>
    <div v-loading.fullscreen.lock="!isInit" :class="customAppPageClassNames">
        <el-config-provider :locale="locale">
            <template v-if="isInit">
                <div v-if="!isFullPage" class="app-page-wrapper">
                    <Header cur-tab="main"></Header>
                    <el-container class="mian-wrap" :class="{
                        'course-detail-style': ['courseDetails', 'newTeacherDetail'].includes(
                            route.name,
                        ),
                        'new-square-style': isNewSquare,
                        'full-main': isFullMain
                    }">
                        <!-- <Menu></Menu> -->
                        <el-main class="page-main-container">
                            <!-- 面包屑 -->
                            <BreadCrumb v-if="isShowBread" :list="crumbList" :menuList="menuList" :parentKey="parentKey"
                                @link-click="jumpCurrent"></BreadCrumb>
                            <router-view v-if="!isUserCenter" />
                            <UserCenter v-else>
                                <router-view />
                            </UserCenter>
                        </el-main>
                    </el-container>
                    <div class="app-footer" v-if="brand?.publishBrand" :class="{ 'full-main-footer': isFullMain, }">
                        <MainFooter :brand="brand" />
                    </div>
                </div>
                <router-view v-else />
            </template>
        </el-config-provider>
        <guide-frame
            v-if="!(route.path?.includes('login') || route.path?.includes('register') || route.path?.includes('20th-anniversary'))"
            :brand="brand" @jump="go" @feedback="feedback"></guide-frame>
        <Feedback @on-close="feedbackShow = false" v-if="feedbackShow" />
    </div>
    <ImproveDialog></ImproveDialog>
</template>
<script setup>
import { BreadCrumb } from '@yanxiu/fragment';
import { GuideFrame } from '@yanxiu/guide-frame';
import ImproveDialog from '@/components/improve-info/index.vue';
import { MainFooter } from '@yanxiu/footer';
import { ElConfigProvider } from 'element-plus';
import Message from '@/components/message/message.js';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { computed, watch, onBeforeMount, getCurrentInstance, ref, provide } from 'vue';
import locationTransfer from '@/global/location-transfer';
import { getContext } from '@/global/container/app-context';
import { checkPlatformPermission } from '@/permission/index.js';
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import Feedback from '@/components/feedback/index';
import { checkIsSuperBrand } from '@/lib/tools';
// 组件区，引入即注册
import Header from '@/components/menu/index.vue';
import UserCenter from '@/components/user-center/index.vue';


const instance = getCurrentInstance();

const store = useStore();
const route = useRoute();
const feedbackShow = ref(false);

// 汉化
const locale = {
    name: 'zh-cn',
    el: {
        ...zhCn.el,
        pagination: {
            goto: '前往',
            pagesize: '条/页',
            total: '共 {total} 条',
            pageClassifier: '页',
        },
    },
};

store.dispatch('user/getMemberUserV3');
const pagePermission = computed(() => {
    return store.state?.pagePermission || {};
});

const moocComName = computed(() => {
    return pagePermission.value?.moocApplication?.moduleNameAlias || pagePermission.value?.moocApplication?.moduleName || '慕课';
});

provide('moocComName', moocComName.value);

const squareKey = computed(() => {
    let moduleRuleList = pagePermission.value['coopgroup:square:temp']?.moduleRuleList || [];
    let temp = '';
    moduleRuleList.forEach(item => {
        if (item.checked) {
            temp = item.ruleKey;
        }
    })
    return temp; // 西城：xicheng, 新疆二师：xinjiang_ershi
})

// 是否全屏
const isFullPage = computed(() => {
    return !!(route.meta || {}).fullScreen || route.path === '/';
});


// 保留header footer的全屏幕
const isFullMain = computed(() => {
    return !!(route.meta || {}).fullMain || route.path === '/';
});

// 是否展示个人中心
const isUserCenter = computed(() => {
    return !!(route.meta || {}).isUserCenter;
});

// 全部备案信息
const brand = computed(() => {
    return store.state.brand || { ver: null, publishBrand: null };
});
const currentUserId = computed(() => {
    return store.state.currentUser.userId;
});

const isInit = computed(() => {
    return true;
});

const menuList = computed(() => {
    let list = store.getters['user/userMenus'] || [];
    return list.filter(item => {
        return item?.path || (item?.sub_navs && item?.sub_navs.length);
    });
});

const isShowBread = computed(() => {
    return route.meta.isShowBread || false;
});

// 面包屑用的所属应用的moduleKey
const parentKey = computed(() => {
    return route.meta.parentKey || [];
});

// 业务上定义的面包屑
const crumbList = computed(() => {
    if (route.meta?.name) {
        return [{ name: route.meta?.name }];
    }
    return store.state.breadCrumbList || [];
});

// 是否是新广场页改版 带背景header
const isNewSquare = computed(() => {
    // 课程广场 / 资源广场
    return [
        'schoolCourseSquare',
        'newTeacherSquare',
        'districtCourseSquare',
        'courseSquare',
        'resource',
        'activitySquare',
        'trainingStar',
        'groupIndex',
        'videoCaseSquare',
        'moocSquare',
        'teachingStudio',
        'teachingStudioDynamics',
        'teachingStudioDynamicsResult',
        'activitySquareTrain',
    ].includes(route.name);
});

// 滚动
const height = computed(() => {
    return route.meta.parentKey || [];
});

// 自定义页面样式
const customAppPageClassNames = computed(() => {
    if (route.name == 'activitySquare' && ['union', 'school'].includes(route.params.type)) {
        return ['app-page', 't_zxykt', 'cqbsxx41'];
    }
    // 十三中项目协作组页面复制+整体背景添加
    if (route.name == 'groupIndexCopy') {
        return ['app-page', 'group_copy'];
    }
    return [
        'app-page',
        brand.value?.publishBrand?.brandTenant?.tenant,
        brand.value?.publishBrand?.brand,
    ];
});

watch(
    () => route.name,
    async val => {
        if (checkIsSuperBrand()) {
            document.title = '中台品牌管理';
            return;
        }

        window.scrollTo(0, 0);
        // 系统当前计分模式
        // store.dispatch('common/getScoreMode');
        if (!store.state.user?.initialized) {
            // 初始化执行一次后不再执行（除非重新刷新页面）
            try {
                store.dispatch('common/getInstitutionByBrand');
                await store.dispatch('user/init');
                await getContext.call(instance);
                // 检测是否有相关页面及业务访问权限
                if (!['login', 'redirect'].includes(route.name)) {
                    checkPlatformPermission.call(instance, route);
                }
            } catch (err) {
                console.log(err);
            }
        } else {
            // 检测是否有相关页面及业务访问权限
            if (!['login', 'redirect'].includes(route.name)) {
                checkPlatformPermission.call(instance, route);
            }
        }

        if (!['login', 'redirect'].includes(route.name)) {
            if (!store.state.user?.initUserInfo) {
                try {
                    // 判断是否请求用户信息
                    await store.dispatch('user/getCurrentUser');
                } catch (err) {
                    console.log(err);
                }
            }
        }
        setNavName();
    },
);

function feedback () {
    if (!currentUserId.value) {
        console.log('logout', 111)
        store.dispatch('logout');
        return false;
    }
    feedbackShow.value = true;
}

// 更新网页标题
function setNavName () {
    let { brandConfig } = brand.value?.publishBrand || {};
    if (route?.meta?.moduleKey && menuList.value.length) {
        let curPath = window.location.origin + route.path;
        let cur = menuList.value.find(item => {
            if (item?.sub_navs?.length) {
                return item.sub_navs.find(
                    subItem =>
                        subItem.moduleKey === route.meta.moduleKey || subItem.link === curPath,
                );
            }
            return item.moduleKey === route.meta.moduleKey || item.link === curPath;
        });
        let title = cur?.title || route?.meta?.title || '';
        document.title = title ? `${title}-${brandConfig.siteName}` : brandConfig.siteName;
    } else {
        let title = route?.meta?.title || '';
        document.title = title ? `${title}-${brandConfig.siteName}` : brandConfig.siteName;
    }
}

// 全局消息提示
G_listenEvent('toast', newMsg => {
    Message({ text: newMsg.message, type: newMsg.type || 'error' });
});

// toErrorPage
G_listenEvent('toErrorPage', newMsg => {
    store.commit('meta', {
        pageMessage: newMsg,
    });
});

onBeforeMount(() => { });

function go (url) {
    locationTransfer.pageJump(url, true);
}

// 在当前页跳转
function jumpCurrent (url) {
    locationTransfer.pageJump(url);
}

// 相当于created
locationTransfer.registerRouter();
</script>

<style lang="scss">
@import '~@/assets/styles/common.scss';
@import '~@/assets/iconfont/iconfont.css';
@import '~@/assets/fonts/dinalternate.css';

#app {
    font-family: 'Microsoft YaHei', 微软雅黑;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--main-text-color);
    background: var(--main-bg-color);
    min-height: 100vh;
    min-width: 1200px;
    overflow-x: hidden;
}

* {
    padding: 0;
    margin: 0;
    list-style: none;
}

a:hover {
    color: unset !important;
}

.mian-wrap {
    width: 1200px;
    margin: 20px auto 0;
    min-height: calc(100vh - 108px);

    .el-main {
        overflow: inherit;
    }

    .page-main-container {
        padding: 0;
    }
}

.course-detail-style {
    position: relative;
    margin: 0 auto;
    padding-top: 20px;
    width: 100%;

    .bread-header-wrap {
        width: 1200px;
        margin: 0 auto;
        position: relative;
        z-index: 1;
    }
}

.new-square-style,
.full-main {
    position: relative;
    margin: 0 auto;
    width: 100%;

    .bread-header-wrap {
        width: 1200px;
        margin: 0 auto;
        position: relative;
        z-index: 1;
    }
}

.app-footer {
    margin-top: 70px;
    &.full-main-footer {
        margin-top: 0;
    }
}
</style>
